module.exports = __webpack_public_path__ + "img/pause-icon.94607298.png";